var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1503,
    height: 737,
    viewBox: "0 0 1503 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M905.5 737C721.543 737 350.957 688.438 18.0154 564.305C7.14384 560.252 0 549.838 0 538.235V28.5C0 13.036 12.536 0.5 28 0.5H1313.87C1331.37 0.5 1333.45 8.22534 1318.71 17.6416C1276.3 44.7236 1213.38 105.141 1324.5 214.5C1445.6 333.679 1568.09 417.294 1461.57 570.998C1452.64 583.87 1441.87 595.489 1429.47 605.056C1295.14 708.71 1037.81 737 905.5 737Z",
    fill: "url(#paint0_linear_1_349)",
    fillOpacity: 0.36
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_349",
    x1: 779.844,
    y1: 17.5,
    x2: 779.844,
    y2: 898.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/Blob1.addc9ce24be986ca2fe974d15e3de031.svg";
export { ForwardRef as ReactComponent };